<template>
  <div>
    <vs-card>
      <b-row align-h="start">
        <!--
        <b-col cols="4">
          <b-row>
            <b-col lg="3" style="text-align: start" align-self="center">
              <b-form-group
                style="font-size: small; font-weight: bold"
                :label="$t('Customer')"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label-for="item-name">
                <v-select
                  color="danger"
                  v-model="customer"
                  :options="customer_choices"
                  size="small"
                  label="name"
                  v-on:input="getCustomerSerialList"
                  autocomplete
                  ref="selectElement"
                  name="customer"
                  v-validate="'required'"
                >
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
			-->
        <b-col cols="5"
          ><b-row>
            <b-col lg="4" style="text-align: start" align-self="center">
              <b-form-group
                style="font-size: small; font-weight: bold"
                :label="'* ' + $t('SerialNumber')"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label-for="item-name">
                <v-select
                  color="danger"
                  v-model="serialNumber"
                  :options="serialNumber_options"
                  :disabled="ProductExpertiseHeadId != ''"
                  size="small"
                  autocomplete
                  ref="selectElementSerial"
                  name="customer"
                  label="name"
                  :taggable="true"
                >
                </v-select>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="5"
          ><b-row>
            <b-col lg="4" style="text-align: start" align-self="center">
              <b-form-group
                style="font-size: small; font-weight: bold"
                :label="'* ' + $t('TransCode')"
                label-for="h-first-name"
              >
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label-for="item-name">
                <vs-input
                  size="small"
                  v-model="productTransCode"
                  :disabled="ProductExpertiseHeadId != ''"
                  type="text"
                  class="w-full"
                  name="productTransCode"
                  ref="productTransCode"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <b-col cols="3" md="auto" style="padding-right: 2px">
          <b-col>
            <b-row align-h="end">
              <b-col cols="3" md="auto">
                <b-button
                  class="bg-success"
                  style="border-color: white"
                  v-on:click="submitData()"
                >
                  <Icon
                    :icon="'material-symbols:save'"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Save") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
      <vs-divider></vs-divider>
      <b-row class="mt-5">
        <b-col cols="4" style="padding-right: 2px" v-if="!isUpdateProductExpertize">
          <b-col>
            <b-row>
              <b-col lg="4" style="text-align: start" align-self="center">
                <b-form-group
                  style="font-size: small; font-weight: bold"
                  :label="'* ' + $t('ProductGroup')"
                  label-for="h-first-name"
                >
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label-for="item-name">
                  <v-select
                    color="danger"
                    v-model="productGroup"
                    :options="productgroup_choices"
                    size="small"
                    label="name"
                    autocomplete
                    ref="selectElement"
                    name="productGroup"
                    @input="getShemeProperty"
                  >
                  </v-select>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
        <b-col cols="3" md="auto" style="padding-right: 2px">
          <b-col>
            <b-row align-h="end">
              <b-col cols="3" md="auto">
                <b-button
                  class="bg-danger"
                  style="border-color: white"
                  v-on:click="clearList()"
                >
                  <Icon
                    :icon="'ic:baseline-clear'"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("Clear") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-col>

        <b-col cols="3" md="auto" style="padding-right: 2px">
          <b-col>
            <b-row align-h="end">
              <b-col cols="3" md="auto">
                <b-button
                  class="bg-primary"
                  style="border-color: white"
                  v-on:click="getExpertizeList()"
                >
                  <Icon
                    :icon="'ep:list'"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("ListExpertize") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
        <b-col cols="3" md="auto" style="padding-right: 2px">
          <b-col>
            <b-row align-h="end">
              <b-col cols="3" md="auto">
                <b-button
                  class="bg-warning"
                  style="border-color: white"
                  v-on:click="addStockExpertizeSheme()"
                >
                  <Icon
                    :icon="'mingcute:add-line'"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("AddNewStockExpertizeSheme") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <table class="w-full permissions-table">
        <tr>
          <th
            class="font-semibold text-base text-left px-3 py-2"
            v-for="heading in [
              $t('Property'),
              $t('Fine'),
              $t('Average'),
              $t('Bad'),
              $t('Description'),
            ]"
            :key="heading"
          >
            {{ heading }}
          </th>
        </tr>

        <tr
          v-for="(val, ind) in allPropertysData"
          :key="ind"
          style="border-bottom: 0.2px solid rgba(0, 0, 0, 0.1)"
        >
          <td class="px-3 py-2" style="font-weight: 600; font-size: medium">
            {{ val.ProductPropertyName }}
          </td>
          <td class="custom-radio-lg">
            <b-form-radio
              v-model="val.ProductPropertyValue"
              :name="'radio-group-' + ind"
              size="lg"
              value="1"
            ></b-form-radio>
          </td>
          <td class="custom-radio-lg">
            <b-form-radio
              v-model="val.ProductPropertyValue"
              :name="'radio-group-' + ind"
              size="lg"
              value="2"
            ></b-form-radio>
          </td>
          <td class="custom-radio-lg">
            <b-form-radio
              v-model="val.ProductPropertyValue"
              :name="'radio-group-' + ind"
              size="lg"
              value="3"
            ></b-form-radio>
          </td>
          <td class="px-3 py-2">
            <b-form-textarea
              v-model="val.ProductPropertyDescription"
              id="textarea"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </td>
        </tr>
      </table>

      <b-row align-h="end">
        <b-col cols="3" md="auto" style="padding-right: 2px">
          <b-col>
            <b-row align-h="end">
              <b-col cols="3" md="auto">
                <b-button
                  class="bg-warning"
                  style="border-color: white"
                  v-on:click="addImage()"
                >
                  <Icon
                    :icon="'mdi-light:image'"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("AddImage") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
        <b-col cols="3" md="auto" style="padding-right: 2px">
          <b-col>
            <b-row align-h="end">
              <b-col cols="3" md="auto">
                <b-button
                  class="bg-success"
                  style="border-color: white"
                  v-on:click="completeProcess()"
                >
                  <Icon
                    :icon="'mingcute:add-line'"
                    style="margin-right: 5px"
                    width="20"
                    height="20"
                  />{{ $t("CompleteProcess") }}
                </b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
    </vs-card>
    <vs-popup
      class="holamundo"
      :title="$t('AddImage')"
      :active.sync="isSidebarActiveImage"
      fullscreen
      @cancel="clearFields"
      @close="clearFields"
    >
      <b-row>
        <b-col lg="5">
          <b-row align-v="center">
            <vs-card>
              <b-row class="mb-8 mt-8">
                <UploadImageDynamic :isUploaded="isUploaded" :uploadMethod="'setImage'" />
              </b-row>
              <b-row class="justify-content-md-end">
                <b-col cols="12" md="auto" class="ml-2" style="padding: 0px">
                  <b-button
                    class="bg-danger"
                    style="border-color: white"
                    v-on:click="clearFields()"
                  >
                    <Icon
                      icon="material-symbols:cancel-outline"
                      style="margin-right: 5px"
                      width="20"
                      height="20"
                    />{{ $t("Cancel") }}
                  </b-button>
                </b-col>

                <b-col cols="12" md="auto" style="padding: 0px">
                  <b-button
                    style="border-color: white"
                    v-on:click="imageSave()"
                    class="vs-con-loading__container bg-primary"
                    id="loading-stockList"
                  >
                    {{ $t("SaveImage") }}
                  </b-button></b-col
                >
              </b-row>
            </vs-card>
          </b-row>
        </b-col>
        <b-col>
          <vs-card>
            <div v-if="previewUrl">
              <b-row>
                <b-col v-for="(url, index) in previewUrl" :key="index" lg="3">
                  <b-button
                    v-on:click="clearLocalImage(index)"
                    size="sm"
                    variant="outline-light"
                  >
                    <Icon
                      icon="material-symbols:close"
                      width="25"
                      height="25"
                      v-b-tooltip.hover.bottom="$t('Delete')"
                      color="#ea5455"
                    />
                  </b-button>
                  <img :src="url.ProductExpertiseImageFilePath" style="width: 100%" />
                </b-col>
              </b-row>
              <b-row>
                <b-col v-for="(url, index) in addedImage" :key="index" lg="3">
                  <b-button
                    v-on:click="removeExpertizeImage(url)"
                    size="sm"
                    variant="outline-light"
                  >
                    <Icon
                      icon="material-symbols:close"
                      width="25"
                      height="25"
                      v-b-tooltip.hover.bottom="$t('Delete')"
                      color="#ea5455"
                    />
                  </b-button>
                  <img
                    :src="imageUrl + url.ProductExpertiseImageFilePath"
                    style="width: 100%"
                    :alt="'Image ' + index"
                  />
                </b-col>
              </b-row>
            </div>
          </vs-card>
        </b-col>
      </b-row>
    </vs-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import UploadImageDynamic from "../components/global-components/UploadImageDynamic.vue";
import userJson from "../../../public/user.json";
export default {
  components: {
    Icon,
    vSelect,
    UploadImageDynamic,
  },
  data() {
    return {
      imageUrl: userJson.imageUrl,
      isSidebarActiveImage: false,
      isUploaded: false,
      productgroup_choices: [],
      productGroup: "",
      productTransCode: "",
      ProductExpertiseHeadId: "",
      serialNumber: "",
      serialNumber_options: [],
      customer_choices: [],
      customer: "",
      allPropertysData: [],
      selectedFile: [],
      previewUrl: [],
      addedImage: [],
      isUpdateProductExpertize: false,
    };
  },
  methods: {
    removeExpertizeImage(item) {
      const vs = this.$vs;
      this.$store
        .dispatch("stock/deleteProductExpertizeImage", item.ProductExpertiseImageId)
        .then((response) => {
          if (response.status == 200) {
            try {
              vs.notify({
                text: response.data.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.imageList();
            } catch (error) {
              console.log(error);
            }
          } else
            vs.notify({
              text: response.toString(),
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
              position: "top-center",
            });
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    formatPath(path) {
      return path.replace(/^.*?(UploadsImage\/)/, "$1");
    },
    convertToWebPath(path) {
      return path.replace(/\\/g, "/");
    },

    clearLocalImage(index) {
      this.selectedFile.splice(index, 1);
      this.previewUrl.splice(index, 1);
    },
    getExpertizeListDetail() {
      this.$store
        .dispatch("stock/listProductExpertizeItemForHead", this.ProductExpertiseHeadId)
        .then((response) => {
          if (response.success == true) {
            try {
              this.allPropertysData = JSON.parse(response.json);

              this.isUpdateProductExpertize = true;
            } catch (error) {
              console.log(error);
            }
          } else {
            console.log(response.data.message.toString());
          }
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    imageList() {
      this.$store
        .dispatch("stock/listProductExpertizeImageForSerial", this.serialNumber.name)
        .then((response) => {
          if (response.success == true) {
            try {
              this.addedImage = JSON.parse(response.json);
            } catch (error) {
              console.log(error);
            }
          } else {
            this.addedImage = [];
            console.log(response.data.message.toString());
          }
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    imageSave() {
      if (!this.selectedFile) {
        alert("Lütfen bir dosya seçin!");
        return;
      }
      const vs = this.$vs;
      let formData = new FormData();
      this.selectedFile.forEach((val, ind) => {
        formData.append(`ImageFile`, val);
      });
      formData.append("ProductExpertiseHeadId", this.ProductExpertiseHeadId);
      formData.append("Serial", this.serialNumber.name);
      this.$store
        .dispatch("stock/addProductExpertizeImage", formData)
        .then((response) => {
          try {
            if (response.success == true) {
              vs.notify({
                text: response.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
              this.previewUrl = [];
              this.imageList();
            } else {
              vs.notify({
                text: response.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } catch (error) {
            console.log(error);
          }
        })
        .catch((error) => {
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    setImage(data) {
      data.forEach((val, index) => {
        this.previewUrl.push({ ProductExpertiseImageFilePath: URL.createObjectURL(val) });
        this.selectedFile.push(val);
      });
    },
    clearFields() {
      this.isUploaded = false;
      this.previewUrl = [];
      this.selectedFile = [];
    },
    addImage() {
      this.isSidebarActiveImage = true;
      this.imageList();
    },
    completeProcess() {
      const vs = this.$vs;
      let method = "";
      let obj = [];
      if (this.isUpdateProductExpertize) {
        method = "updateProductExpertizeItem";
        this.allPropertysData.forEach((val, index) => {
          obj.push({
            productExpertiseId: val.ProductExpertiseId,
            productPropertyName: val.ProductPropertyName,
            productPropertyValue: val.ProductPropertyValue,
            productPropertyDescription: val.ProductPropertyDescription,
            checkListShemaPropertyId: val.CheckListShemaPropertyId,
            checkListShemaPropertyName: val.ProductPropertyName,

            productExpertiseHeadId: this.ProductExpertiseHeadId,
          });
        });
      } else {
        method = "addProductExpertizeItem";
        this.allPropertysData.forEach((val, index) => {
          var createdId = uuid.v4();

          obj.push({
            productExpertiseId: createdId,
            productPropertyName: val.ProductPropertyName,
            productPropertyValue: val.ProductPropertyValue,
            productPropertyDescription: val.ProductPropertyDescription,
            checkListShemaPropertyId: val.CheckListShemaPropertyId,
            checkListShemaPropertyName: val.ProductPropertyName,

            productExpertiseHeadId: this.ProductExpertiseHeadId,
          });
        });
      }
      this.$store
        .dispatch("stock/" + method, obj)
        .then((response) => {
          try {
            if (response.success == true) {
              this.getExpertizeListDetail();
              this.allPropertysData = [];
              vs.notify({
                text: response.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } else {
              vs.notify({
                text: response.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } catch (error) {
            console.log(error);
          }
        })
        .catch((error) => {
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    getShemeProperty() {
      this.$store
        .dispatch("stock/listExpertizeShemaProperty", this.productGroup.value)
        .then((response) => {
          if (response.success == true) {
            try {
              this.allPropertysData = JSON.parse(response.json);
              this.allPropertysData.forEach((val, index) => {
                this.allPropertysData[index].ProductPropertyName = this.allPropertysData[
                  index
                ].PropertyName;
                this.allPropertysData[index].ProductPropertyValue = "";
                this.allPropertysData[index].ProductPropertyDescription = "";
              });
            } catch (error) {
              console.log(error);
            }
          } else {
            console.log(response.data.message.toString());
          }
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    getProductGroupList() {
      this.productGroupListOption = [];
      this.productgroup_choices = [];
      this.productGroupListOption = this.stockGroupExpertize;
      this.productGroupListOption.forEach((val, index) => {
        this.productgroup_choices.push({
          value: val.CheckListShemaId,
          name: val.CheckListShemaName,
        });
      });
    },
    clearList() {
      this.productTransCode = "";
      this.ProductExpertiseHeadId = "";
      this.serialNumber = "";
    },
    submitData() {
      var createdId = uuid.v4();
      const vs = this.$vs;
      let method = "addProductExpertize";
      this.$validator.validateAll().then((result) => {
        if (result) {
          let obj = {
            productExpertiseHeadId: createdId,
            productTransCode: this.productTransCode,
            stockSerialId: this.serialNumber.value,
            serialNo: this.serialNumber.name,
          };
          if (this.data) {
            method = "updateProductExpertize";
            obj = {
              productExpertiseHeadId: this.productExpertiseHeadId,
              productTransCode: this.productTransCode,
              stockSerialId: this.serialNumber.value,
              serialNo: this.serialNumber.name,
            };
          }
          this.$store
            .dispatch("stock/" + method, obj)
            .then((response) => {
              try {
                if (response.success == true) {
                  vs.notify({
                    text: response.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "success",
                    position: "top-center",
                  });
                } else {
                  vs.notify({
                    text: response.data.message,
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "danger",
                    position: "top-center",
                  });
                }
              } catch (error) {
                console.log(error);
              }
            })
            .catch((error) => {
              return new Promise((resolve, reject) => {
                resolve(false);
              });
            });
        } else {
          vs.notify({
            text: this.$t("Validate"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "warning",
            position: "top-center",
          });
        }
      });
    },
    focusToproductTransCode() {
      const vsInputRef = this.$refs.productTransCode;
      if (vsInputRef) {
        const inputElement = vsInputRef.$el.querySelector("input");
        if (inputElement) {
          inputElement.focus();
        }
      }
    },
    focusToSerialNumber() {
      const selectElement = this.$refs.selectElementSerial;
      if (selectElement) {
        const inputElement = selectElement.$el.querySelector("input");
        if (inputElement) {
          inputElement.focus();
        }
      }
    },
    getCustomerSerialList() {
      this.serialNumber_options = [];
      const vs = this.$vs;
      this.focusToSerialNumber();
      this.$store
        .dispatch("stock/listStockSerialNumbers")
        .then((response) => {
          if (response.success == true) {
            try {
              let serialNumberListOption = JSON.parse(response.json);
              serialNumberListOption.forEach((val, index) => {
                this.serialNumber_options.push({
                  value: val.StockSerialId,
                  name: val.Serial,
                });
              });
            } catch (error) {
              console.log(error);
            }
          } else {
          }
        })
        .catch((error) => {
          console.log(error);
          return new Promise((resolve, reject) => {
            resolve(false);
          });
        });
    },
    getExpertizeList() {
      const url = this.$router.resolve({
        name: "expertize-list",
      }).href;
      window.open(url, "_blank");
    },
    addStockExpertizeSheme(temp) {
      const url = this.$router.resolve({
        name: "expertize-sheme",
      }).href;
      window.open(url, "_blank");
    },
    getCustomerList(id, popup) {
      this.customerListOption = [];
      this.customer_choices = [];
      this.customerListOption = this.companydata;
      this.customerListOption.forEach((val, index) => {
        this.customer_choices.push({ value: val.CompanyId, name: val.CompanyName });
      });
    },
    getStockProductGroupsList() {
      const vs = this.$vs;
      this.$store.dispatch("stock/listExpertizeShema").then((response) => {
        // let costumerList = JSON.parse(response.json);
        if (response.success == true) {
        } else
          console.log(
            response.statusText
          ); /*
		 vs.notify({
			 text: response.statusText,
			 iconPack: "feather",
			 icon: "icon-alert-circle",
			 color: "danger",
			 position: "top-center"
		 });*/
      });
    },
  },
  watch: {
    stockGroupExpertize(val) {
      this.getProductGroupList();
      return val;
    },
    productExpertizeHead(val) {
      this.serialNumber = {
        name: val.SerialNo,
        value: val.StockSerialId,
      };
      this.productTransCode = val.ProductTransCode;
      this.ProductExpertiseHeadId = val.ProductExpertiseHeadId;
      return val;
    },
    companydata(val) {
      this.getCustomerList();
      return val;
    },
  },
  computed: {
    stockGroupExpertize: {
      get() {
        return this.$store.state.stock.StockExpertize;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    productExpertizeHead: {
      get() {
        return this.$store.state.stock.ProductExpertizeHead;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    companydata: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
  },
  mounted() {
    this.focusToSerialNumber();
    this.$root.$on("setImage", (data) => {
      if (data) this.isUploaded = true;
      this.setImage(data);
    });
  },
  beforeDestroy() {
    this.$root.$off("setImage");
  },
  created() {
    //  this.getCustomerList();
    this.getStockProductGroupsList();
    this.getCustomerSerialList();
    if (this.$route.params.data) {
      let expertizeRouteParam = JSON.parse(this.$route.params.data);
      this.serialNumber = {
        name: expertizeRouteParam.SerialNo,
        value: expertizeRouteParam.StockSerialId,
      };
      this.productTransCode = expertizeRouteParam.ProductTransCode;
      this.ProductExpertiseHeadId = expertizeRouteParam.ProductExpertiseHeadId;
      this.getExpertizeListDetail();
    }
  },
};
</script>
<style lang="scss" scoped>
.custom-radio-lg {
  transform: scale(1.5);
}

.custom-radio-lg input[type="radio"]:hover + label {
  color: --vs-primary;
}

.custom-radio-lg input[type="radio"]:focus + label {
  outline: 2px solid --vs-primary;
}
</style>
